import { createLibI18n, i18n } from '@w/react-i18n'

export const contentBlocksEditorTranslations = {
  contentBlocksEditor: {
    placeholders: {
      prompt: 'Ask a clear question',
      option: i18n`Option ${'number'}`,
      criterion: 'Grading criterion',
      answer: 'Accepted answer',
      answerRegexp: 'e.g. ^(cat|feline)$',
      transcript: 'Reference transcript',
      explanation: 'Explain why this answer is correct',
      note: 'Type your note',
      cloze: 'Cloze answer',
    },
    document: {
      whiteboard: 'Whiteboard',
      editor: 'Document editor',
      editing: 'Editing document',
      shape: 'Document shape',
      anchorHandle: 'anchor selection handle',
      focusHandle: 'focus selection handle',
      playAudio: 'Play audio',
      pauseAudio: 'Pause audio',
      portals: { video: 'video portal', audio: 'audio portal', file: 'file portal', preview: 'preview portal', recorder: 'recorder portal' },
      divider: 'Divider',
      audio: 'Audio',
      pages: 'Pages',
      blankTitle: 'Start with an idea',
      completed: 'Completed',
      notCompleted: 'Not completed',
      math: 'Math',
      copyCode: 'Copy code',
      fullscreen: 'Fullscreen',
      expandDiagram: 'Expand diagram',
      graph: 'Graph',
      mermaid: 'Mermaid diagram',
      video: 'Video',
      playYoutube: 'Play YouTube video',
      youtube: 'YouTube video',
      alert: 'Alert',
      pageUnavailable: 'Page unavailable',
      question: 'Question',
      gradingCriteria: 'Grading criteria',
      referenceAnswer: 'Reference answer',
      exactMatch: 'Exact match',
      done: 'Done',
      preview: 'Preview',
      addAnswerButton: '+ Add answer',
      addAnswer: 'Add answer',
      advanced: 'Advanced',
      addCriterionButton: '+ Add criterion',
      addCriterion: 'Add criterion',
      addOptionButton: '+ Add option',
      addOption: 'Add option',
      settings: 'Settings',
      trainingAnswer: 'Type your answer',
      answerPrefix: 'Answer: ',
      answersPrefix: 'Answers: ',
      explanation: 'Explanation',
      yourAnswer: 'Your answer',
      untitledPage: 'Untitled page',
      paragraph: "Write, or type '/' for commands",
      image: 'image',
      ellipsis: '...',
      hiddenCloze: '…',
      low: 'low',
      medium: 'medium',
      high: 'high',
      download: i18n`Download ${'name'}`,
      openPage: i18n`Open ${'name'}`,
      removeAnswer: i18n`Remove accepted answer ${'number'}`,
      removeCriterion: i18n`Remove grading criterion ${'number'}`,
      markCorrect: i18n`Mark option ${'number'} correct`,
      selectOption: i18n`Select option ${'number'}`,
    },
    errors: {
      fileUploadFailed: 'File upload failed',
      effectFailed: 'Something went wrong',
    },
  },
} as const

export const contentBlocksEditorI18n = createLibI18n({
  defaultTranslations: contentBlocksEditorTranslations,
})

// oxlint-disable-next-line typescript/unbound-method -- destructured hook; not a method call
export const { useTranslation } = contentBlocksEditorI18n
export type ContentBlocksEditorTranslations =
  typeof contentBlocksEditorTranslations
